import React from 'react'
import { colors } from './shibui';

export default {
  CTASVG: () => (
    <svg
      style={{ position: 'absolute', top: '-45%', left: '50%', transform: 'translateX(-50%)' }} 
      width="1440" height="791" viewBox="0 0 1440 791" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <rect id="a-23i2388" width="1577" height="672" rx="20" />
        <linearGradient x1="-56.4856953%" y1="62.499299%" x2="82.7441255%" y2="42.0954089%" id="c-reiurwiu">
          <stop stopColor={colors.amethyst50.color} offset="0%" />
          <stop stopColor={colors.graphite.color} offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-58 59.192)">
          <use href="#a-23i2388" />
        </g>
        <path d="M310.725 106.694h110.017c34.77 0 47.378 3.62 60.089 10.418 12.711 6.798 22.687 16.774 29.485 29.485 6.798 12.71 10.418 25.319 10.418 60.088v110.017c0 34.77-3.62 47.378-10.418 60.089-6.798 12.71-16.774 22.687-29.485 29.485-12.711 6.798-25.32 10.418-60.089 10.418H310.725c-34.769 0-47.377-3.62-60.088-10.418-12.711-6.798-22.687-16.774-29.485-29.485-6.798-12.711-10.418-25.32-10.418-60.089V206.685c0-34.769 3.62-47.377 10.418-60.088 6.798-12.711 16.774-22.687 29.485-29.485 12.711-6.798 25.32-10.418 60.088-10.418z" fill="url(#c-reiurwiu)" transform="rotate(-150 344.664 299.06)" />
        <path d="M1131.725 253.694h110.017c34.77 0 47.378 3.62 60.089 10.418 12.711 6.798 22.687 16.774 29.485 29.485 6.798 12.71 10.418 25.319 10.418 60.088v110.017c0 34.77-3.62 47.378-10.418 60.089-6.798 12.71-16.774 22.687-29.485 29.485-12.711 6.798-25.32 10.418-60.089 10.418h-110.017c-34.769 0-47.377-3.62-60.088-10.418-12.711-6.798-22.687-16.774-29.485-29.485-6.798-12.711-10.418-25.32-10.418-60.089V353.685c0-34.769 3.62-47.377 10.418-60.088 6.798-12.711 16.774-22.687 29.485-29.485 12.711-6.798 25.32-10.418 60.088-10.418z" fill="url(#c-reiurwiu)" transform="rotate(30 1047.28 330.06)" />
      </g>
    </svg>
  )
}




// WEBPACK FOOTER //
// ./src/components/assets/ctabg.js